// src/hooks/useTooltipState.js
import { useState, useEffect, useCallback } from 'react';

const useTooltipState = (tooltipName, initialDelay = 0, initialVisibility = false) => {
  const [state, setState] = useState(() => ({
    visible: initialVisibility && !localStorage.getItem(`${tooltipName}_tooltip_seen`),
    completed: !!localStorage.getItem(`${tooltipName}_tooltip_seen`)
  }));

  const show = useCallback(() => {
    if (!localStorage.getItem(`${tooltipName}_tooltip_seen`)) {
      setState({ visible: true, completed: false });
    }
  }, [tooltipName]);

  const dismiss = useCallback(() => {
    localStorage.setItem(`${tooltipName}_tooltip_seen`, 'true');
    setState({ visible: false, completed: true });
  }, [tooltipName]);

  useEffect(() => {
    if (initialDelay && state.visible) {
      const timer = setTimeout(() => {
        dismiss();
      }, initialDelay);
      return () => clearTimeout(timer);
    }
  }, [initialDelay, state.visible, dismiss]);

  return [state, show, dismiss];
};

export default useTooltipState;